/* global window, React, Button, useState, useEffect */
// ============================================================
// AI Regnskapsfører — innboksen i modal
// ============================================================
// Her sto det først en slankere arbeidsliste: raden og redigeringen fra
// innboksen, men uten paginering, flervalg, dra-for-å-slå-sammen, filter og
// opplasting. Tanken var at de hørte til opprydding, ikke til godkjenning.
//
// Det holdt ikke i praksis. Skal du kontrollere nitten bilag, trenger du å
// filtrere dem, ta flere om gangen, bla i dem og slå sammen de to sidene av
// samme faktura — og da er arbeidslista innbokssiden. En egen kopi ville hatt
// halvparten av funksjonene og sin egen vei å drifte.
//
// Derfor monteres `InnboksPage` selv, med `embedded`: sidetittelen faller bort
// (modalen har sin egen) og visningsbytte til papirkurv/dokumentasjon likeså —
// det er ikke innboksarbeid. Alt annet er den samme siden, med den samme koden.

function ApInboxSurfaceModal({ year, onClose, onChanged }) {
  const [changed, setChanged] = useState(false);
  // Siden melder fra selv naar noe er bokfoert, slettet eller endret. Da
  // slipper modalen aa gjette, og koen lastes bare naar noe faktisk skjedde.
  useEffect(() => {
    const handler = () => setChanged(true);
    // Begge: bokfoering melder inn paa innboksen, mens sletting og redigering
    // kan komme som en ren state-endring. Aa laste koen en gang for mye naar
    // modalen lukkes koster lite; aa ikke laste den gir tall som lyver.
    window.addEventListener('plumme-inbox-changed', handler);
    window.addEventListener('plumme-backend-state', handler);
    return () => {
      window.removeEventListener('plumme-inbox-changed', handler);
      window.removeEventListener('plumme-backend-state', handler);
    };
  }, []);
  const close = () => { if (changed && onChanged) void onChanged(); onClose(); };
  // Sidens egne «gaa til»-veier (fri postering, annet salg) skal lukke modalen
  // og navigere, ikke navigere under en modal som blir staaende aapen.
  const routeAway = (route) => { close(); if (route && window.plummeNav) window.plummeNav(route); };
  const Page = window.InnboksPage;
  return <window.ApSurfaceModal title={t('ap.surface.inboxTitle', 'Bilagsinnboksen')} onClose={close}
    footer={<React.Fragment>
      <Button variant="ghost" onClick={close}>{t('common.close', 'Lukk')}</Button>
      <Button variant="secondary" icon="arrowRight" onClick={() => routeAway('innboks')}>{t('ap.yearEnd.openAsPage', 'Åpne som egen side')}</Button>
    </React.Fragment>}>
    {Page ? <Page embedded route="innboks" setRoute={routeAway} year={year} /> : null}
  </window.ApSurfaceModal>;
}

Object.assign(window, { ApInboxSurfaceModal });
